import React, {Component} from 'react'
import { connect } from 'react-redux'
import { routeActions } from 'react-router-redux'
import BookmakerIntro from 'components/getstarted/BookmakerIntro'
import Bankrollintro from 'components/getstarted/Bankrollintro'
import FilteringIntro from 'components/getstarted/FilteringIntro'
import NotificationIntro from 'components/getstarted/NotificationIntro'
import {addList} from 'actions/bookmakerLists'
import 'css/getstarted.less'

class GetStartedContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      index:0
    }
    this.onComplete = this.onComplete.bind(this)
  }

  componentWillMount() {
    //what should happen if there's no bookmaker list? We create one
    if(Object.keys(this.props.bookmakerLists).length === 0) {
      let { dispatch } = this.props
      dispatch(addList())
    }
    else {
      let bookmakerList = Object.keys(this.props.bookmakerLists).map(key => Object.assign({}, this.props.bookmakerLists[key], { key }))[0]


      this.getStartedNodes = [
        <BookmakerIntro
          dispatch={this.props.dispatch}
          onComplete={this.onComplete}
          listId={bookmakerList.key}
          bookmakerList={bookmakerList}
        />,
        <Bankrollintro
          dispatch={this.props.dispatch}
          onComplete={this.onComplete}
          userId={this.props.userId}
          startingBankroll={this.props.startingBankroll}
          currency={this.props.currency}
          currencies={Object.keys(this.props.currencies)}
        />,
        <FilteringIntro
          bookmakerLists={this.props.bookmakerLists}
          onComplete={this.onComplete}
        />,
        <NotificationIntro onComplete={this.onComplete} user={this.props.user} />
      ]


      }
  }

  onComplete() {
    if(this.state.index === this.getStartedNodes.length - 1) {
      window.analytics.track('Get started', {
        completed: true
      })
      const { dispatch } = this.props
      dispatch(routeActions.push('/dashboard'))
    }
    this.setState({
      index: this.state.index + 1
    })
  }


  render() {
    if(!this.getStartedNodes) {
      return (
          <div className='get-started clearfix'>
            <div className='text-center'>
              <p> Refresh the page </p>
            </div>
          </div>
        )
    }
    return (
      <div className='get-started clearfix'>
        <div className='text-center'>
          <img src="/static/edgebet_logo.png" width="15%" className="img logo"></img>
            {this.getStartedNodes[this.state.index]}
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    bookmakerLists: state.bookmakerLists,
    currencies: state.currencies,
    userId: state.auth.user.id,
    user: state.auth.user,
    startingBankroll: state.auth.user.startingBankroll,
    currency:state.auth.user.currency
  }
})(GetStartedContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/GetStartedContainer.js
 **/